import { Store } from '@ngrx/store';
import { distinctUntilChanged, switchMap, take, tap, map, filter } from 'rxjs';
import { ApplicationState } from '@store/application-store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ArrearsLabels } from '../models/arrears-labels.model';
import { getArrearsLabels } from '../selectors/arrears.selectors';
import { ArrearsHttpService } from './arrears-http.service';
import * as arrearsActions from '../actions/arrears.actions';

@Injectable()
export class ArrearsLabelsService {

  getArrearsLabels(): Observable<ArrearsLabels> {
    return this.store
      .select(getArrearsLabels)
      .pipe(
        distinctUntilChanged(),
        tap(labels => {
          if (labels == undefined) {
            this.httpService.getArrearsLabels().subscribe(v => this.store.dispatch(new arrearsActions.LoadLabelsComplete(v)));
          }
        }),
        filter(labels => labels != undefined),
        map(labels => labels)
      );
  }

  constructor(
    private readonly store: Store<ApplicationState>,
    private readonly httpService: ArrearsHttpService
  ) { }

}
